import { defineMessages } from 'react-intl';

export default defineMessages({
	lblClose: {
		id: 'app.booking.ServiceAlerts.close',
		defaultMessage: 'Close',
	},
});
